import InterfaceToothExam from "@/apiInterface/InterfaceToothExam";
import type { ToothExam, ToothExamValue } from "@/types/odontogram";
import ErrorAlert from "@/utility/ErrorAlert";

class DataToothExam {
  async listValues(): Promise<ToothExamValue[]> {
    let dt: ToothExamValue[] = [];
    await InterfaceToothExam.listValues()
      .then((response) => {
        dt = response?.data?.data ?? [];
      })
      .catch((e) => {
        ErrorAlert.showSnackAlert(e, "Tooth Exam Values");
      });

    return dt;
  }

  async getByEncounter(encounterId: string): Promise<ToothExam[]> {
    let dt: ToothExam[] = [];
    await InterfaceToothExam.getByEncounter(encounterId)
      .then((response) => {
        dt = response.data.data || [];
      })
      .catch((e) => {
        ErrorAlert.showSnackAlert(e, "Tooth Exams by Encounter");
      });

    return dt;
  }

  async syncByEncounter(encounterId: string, toothExams: ToothExam[]): Promise<ToothExam[]> {
    let dt: ToothExam[] = [];
    await InterfaceToothExam.syncByEncounter(encounterId, toothExams)
      .then((response) => {
        dt = response.data.data || [];
      })
      .catch((e) => {
        ErrorAlert.showErrorAlert(e);
      });

    return dt;
  }
}

export default new DataToothExam();
